import { render, staticRenderFns } from "./TourStop.vue?vue&type=template&id=38404206&scoped=true&"
import script from "./TourStop.vue?vue&type=script&lang=js&"
export * from "./TourStop.vue?vue&type=script&lang=js&"
import style0 from "./TourStop.vue?vue&type=style&index=0&id=38404206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38404206",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
